import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLock = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-lock';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M8.1 3.281c-.877.118-1.613.813-1.8 1.699-.042.203-.059.553-.059 1.27l-.001.99h-2v13.52h15.52V7.24h-2l-.001-.99c0-1.102-.038-1.387-.237-1.79a2.34 2.34 0 0 0-1.276-1.109l-.266-.09-3.82-.006c-2.101-.004-3.928.008-4.06.026m7.766 1.545a.8.8 0 0 1 .246.206l.108.142.012 1.033.012 1.033H7.76v-.981c0-1.028.018-1.159.185-1.306.226-.201.042-.192 4.049-.193 3.379 0 3.747.006 3.872.066M18.24 14v5.24H5.76V8.76h12.48zm-6.623-2.717c-.585.069-1.098.328-1.552.781a2.7 2.7 0 0 0-.693 1.116c-.091.277-.105.387-.105.82s.014.543.105.82c.146.44.357.781.692 1.116s.676.546 1.116.692c.277.091.387.105.82.105s.543-.014.82-.105c.44-.146.781-.357 1.116-.692s.546-.676.692-1.116c.091-.277.105-.387.105-.82s-.014-.543-.105-.82c-.425-1.294-1.642-2.06-3.011-1.897m.911 1.59c.239.117.481.359.599.599.133.27.133.787 0 1.057-.464.943-1.795.943-2.252 0a1.43 1.43 0 0 1-.074-.871c.097-.348.43-.703.785-.838.232-.088.708-.061.942.053"
    })
  }));
});
export default SvgLock;